import { Component, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { Adjustment } from 'src/app/model/project/adjustment';
import ProjectHelper from 'src/app/helpers/project-helper';
import Contact from 'src/app/model/Contact/contact';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import WindowStickerPlacement from 'src/app/model/product/windowsticker/windowsticker-placement';
import { StringHelper } from 'src/app/helpers/string-helper';
import BoardPlacement from 'src/app/model/product/board/board-placement';
import OtherProductPlacement from 'src/app/model/product/other-product/other-product-placement';

@Component({
  selector: 'adjustment-project-summary',
  templateUrl: './adjustment-project-summary.component.html',
  styleUrls: ['./adjustment-project-summary.component.scss'],
})
export class AdjustmentProjectSummaryComponent implements OnInit {
  @Input()
  subproject: Adjustment;

  @Input()
  project: Project;

  @Input()
  client = false;

  obstacleLines: LineWithHeader[];
  atLeastOneInpressLogo: boolean = false;

  clickLinkStyle = {
    color: '#ff5417',
    cursor: 'pointer',
  };

  ngOnInit() {
    if (
      !this.client &&
      this.project != null &&
      CollectionHelper.isPopulated(this.project.products)
    ) {
      this.obstacleLines = [];
      this.project.products.forEach((p, i) => {
        this.atLeastOneInpressLogo =
          this.atLeastOneInpressLogo || p.inpressLogo;
        if (
          ProductHelper.isWindowSticker(p) ||
          ProductHelper.isCustomWindowSticker(p)
        ) {
          if (p.productPlacement != null) {
            const windowStickerPlacement = <WindowStickerPlacement>(
              p.productPlacement
            );
            if (
              windowStickerPlacement.windowObstacle &&
              !StringHelper.isEmpty(
                windowStickerPlacement.extraInfoWindowObstacle
              )
            ) {
              this.obstacleLines.push({
                header: `${ProductHelper.getTypeOf(p)} #${i + 1}: `,
                line: windowStickerPlacement.extraInfoWindowObstacle,
              });
            }
          }
        } else if (ProductHelper.isBoard(p)) {
          if (p.productPlacement != null) {
            const boardPlacement = <BoardPlacement>p.productPlacement;
            if (
              boardPlacement.obstaclesPresent &&
              !StringHelper.isEmpty(boardPlacement.obstaclesInfo)
            ) {
              this.obstacleLines.push({
                header: `${ProductHelper.getTypeOf(p)} #${i + 1}: `,
                line: boardPlacement.obstaclesInfo,
              });
            }
          }
        } else if (ProductHelper.isOtherProduct(p)) {
          if (p.productPlacement != null) {
            const otherProductPlacement = <OtherProductPlacement>(
              p.productPlacement
            );
            if (
              otherProductPlacement.obstaclesPresent &&
              !StringHelper.isEmpty(otherProductPlacement.obstaclesInfo)
            ) {
              this.obstacleLines.push({
                header: `${ProductHelper.getTypeOf(p)} #${i + 1}: `,
                line: otherProductPlacement.obstaclesInfo,
              });
            }
          }
        }
      });
    }
  }

  mail(email: String, contact: Contact): String {
    return (
      'mailto:' +
      email +
      '?Subject=' +
      ProjectHelper.getAdjustmentMailSubjectLine(
        this.subproject,
        this.project
      ) +
      '&body=Beste ' +
      contact.firstName +
      ','
    );
  }

  getBaseProject() {
    return ProjectHelper.getBaseProject(this.project);
  }
}

interface LineWithHeader {
  header: string;
  line: string;
}
